import React from 'react';
import DialogBox from '@techsoftware/happay-widgets/DialogBox';
import Grid from '@techsoftware/happay-widgets/Grid';
import Button from '@techsoftware/happay-widgets/Button';
import CreateNewVendorImg from '../../../../assets/images/create-vendor.svg';

export default function CreateVendorPopup({ onClick }) {
  return (
    <DialogBox
      open
      id="create-vendor"
      bodyStyle={{ marginBottom: '0px' }}
      dialogTitleContainerStyle={{ fontWeight: '600' }}
      width="500px"
    >
      <Grid
        container
        alignItems="center"
        justify="center"
        className="padding-30"
      >
        <img src={CreateNewVendorImg} alt="create-new-vendor" />
        <div className="heading-h2 margin-t-16">
          Uh ho! No Vendors are added here
        </div>
        <div className="margin-b-24 margin-t-8 full-width align-center">
          Create a vendor to add Invoices.
        </div>
        <Button text="New Vendor" startIcon="add" onClick={onClick} />
      </Grid>
    </DialogBox>
  );
}
